<template>
  <v-app>
    <v-main>
      <v-container>
        <!-- <v-row no-gutters class="mt-8">
          <v-col cols="12" sm="12">
            <v-card
              v-if="vendor === 'moramyun'"
              class="d-flex justify-center"
              flat
            >
              <div>
                <h2 class="mb-2 text-center">
                  FREE BEVERAGE! 🤩
                </h2>
                <h3 class="my-6">
                  Leave a 5 star review on Google, or share your experience on
                  TikTok or Instagram. Then show us your post to get a free
                  drink. One post per person per visit.
                </h3>
                <v-btn
                  large
                  block
                  color="primary"
                  type="submit"
                  @click="goToMenu"
                >
                  Take me to menu
                </v-btn>

                <img
                  src="@/assets/pop.jpeg"
                  alt="pop"
                  class="mt-6"
                  style="width:100%"
                />
              </div>
            </v-card>
          </v-col>
        </v-row> -->
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/analytics";

export default {
  name: "App",

  components: {},

  data: () => ({
    name: "",
    phone: "",
    valid: false,
    showInputFields: true,
    showRequestField: false,
    menuLink: "",
  }),
  computed: {
    vendor() {
      if (window.location.host.split(".")[0] === "check") {
        return window.location.host.split(".")[1];
      } else {
        return window.location.hash.replace("#/", "");
      }
    },
  },
  created() {
    console.log(window.location.host);
    console.log(this.vendor);

    firebase.analytics().logEvent(`vendor_${this.vendor}`);

    if (this.vendor === "moramyun") {
      window.location.href = "https://www.moramyun.com/menu";
      return;
    }

    if (this.vendor === "mymychickenthornhill") {
      window.location.href = "https://www.mymychicken.ca/menu";
      return;
    }
    // For all other vendors
    if (this.vendor === "daeco") {
      window.location.href = "http://daecosushi.ca/our-menu/";
    }
    if (this.vendor === "sapporo") {
      window.location.href = "https://sapporosushi.biz/menu0.html";
    }
    if (this.vendor === "guirei") {
      window.location.href =
        "https://firebasestorage.googleapis.com/v0/b/moramyun-7cc8f.appspot.com/o/Guirei%2Fguirei.pdf?alt=media&token=c185ec64-6209-4180-87b8-99ddef9ad2f9";
    }
  },
  methods: {
    submit() {},
    goToMenu() {
      if (this.vendor === "moramyun") {
        window.location.href = "https://www.moramyun.com/menu";
        return;
      }
    },
    save() {
      console.log(this.name, this.phone);

      const date = new Date()
        .toISOString()
        .split("T")[0]
        .replace(/-/g, "");
      var db = firebase.firestore();
      db.collection("customers_" + date)
        .doc()
        .set({
          name: this.name,
          phone: this.phone,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          restaurant: this.vendor,
        })
        .then(() => {
          console.log("Document successfully written!");
          // Vendor specific actions

          if (this.vendor === "moramyun") {
            this.showInputFields = false;
            this.showRequestField = true;
            this.menuLink = "https://www.moramyun.com/menu";
            // window.location = "https://www.moramyun.com/menu";
            return;
          }
          if (this.vendor === "mymychickenthornhill") {
            window.location = "https://www.mymychickenthornhill.com/menu";
            return;
          }

          // For all other vendors
          if (this.vendor === "daeco") {
            this.menuLink = "http://daecosushi.ca/our-menu/";
          }
          if (this.vendor === "sapporo") {
            this.menuLink = "https://sapporosushi.biz/menu0.html";
          }

          if (this.vendor === "guirei") {
            this.menuLink =
              "https://firebasestorage.googleapis.com/v0/b/moramyun-7cc8f.appspot.com/o/Guirei%2Fguirei.pdf?alt=media&token=c185ec64-6209-4180-87b8-99ddef9ad2f9";
          }

          this.showInputFields = false;
          this.showRequestField = true;
          return;
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
        });
    },
  },
};
</script>
